import SEPlayApi from '../SEPlayApi';

export function getOrderPhotoStatus(orderId:number) {
    return SEPlayApi.getPhotoStatus(orderId);
}